export default __webpack_public_path__ + "static/media/ff-cloud-hover.dbd3b1b4.svg";